import { useTheme } from 'styled-components'

export const useFormIconsStyle = () => {
  const { colors } = useTheme()
  const iconStyle = { color: colors.grey2 }
  return iconStyle
}
